export const buttonStyle = {
  boxShadow: '0 0 0 0 transparent',
  textTransform: 'none',
  fontWeight: 400,
  borderRadius: 25,
  lineHeight: '14px',
  padding: '9px 30px',
}
export const buttonPrimaryStyle = {
  ...buttonStyle,
  boxShadow: '0px 3px 6px #00000029',
}
